import { firebaseSdk } from './firebaseSdk'

export const firestore = firebaseSdk.firestore && firebaseSdk.firestore()
